import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from '../../lib'
import {doMETHOD_ADD_TASK, doREQUEST_ERROR, doREQUEST_COMPLETE} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_TASK_DUPLICATE = 'REQUEST_TASK_DUPLICATE'
export const doREQUEST_TASK_DUPLICATE = createDoRequestAction(REQUEST_TASK_DUPLICATE)

export const requestTaskDuplicateActionCreators = {
  doREQUEST_TASK_DUPLICATE,
}

export function* requestTaskDuplicate({payload, setRequestResult}: any): SagaIterator {
  debug('saga*requestTaskDuplicate')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        taskId: v.string().uuid().exist(),
        methodId: v.string().uuid().optional(),
        name: v.string().optional(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_DUPLICATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {taskId, methodId, name} = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/task-duplicate`,
    accessToken,
    data: {
      taskId,
      name,
      methodId,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_DUPLICATE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/task-duplicate',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(doMETHOD_ADD_TASK(result.payload)) // TODO: not sure need to test

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_TASK_DUPLICATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* taskDuplicateSaga() {
  yield takeEvery(REQUEST_TASK_DUPLICATE, requestTaskDuplicate)
}
